import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Col, Input, Nav, NavItem, NavLink, Row, TabContent, TabPane,} from 'reactstrap';
import classnames from 'classnames';
import departmentSelectors from '../../store/department/selectors';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import attachmentsActionCreators from '../../store/attachments/action-creators';
import notesActionCreators from '../../store/notes/action-creators';
import trainingPhaseSelectors from '../../store/training-phases/selectors';
import DynamicForm from './dynamic-form/DynamicForm';
import AttachmentList from './attachments/AttachmentList';
import AttachmentAdd from './attachments/AttachmentAdd';
import NoteAdd from './notes/NoteAdd';
import NoteEdit from './notes/NoteEdit';
import NoteList from './notes/NoteList';
import Modal from '../../../shared/ui/Modal';
import {Auth} from "../../../shared/services/aws";
import notificationsActionsCreator from "../../store/notifications/action-creators";

class ScheduledReportAdd extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '2',
      authToken: '',
      selectedShift: null,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.props.loadReportEdit(this.props.isAddingScheduedReport);
    this.props.onUpdateReport && this.props.onUpdateReport(this.props.report)

    Auth.currentSession()
      .then(res => {
        this.setState({
          authToken: res.accessToken.jwtToken,
          selectedShift: this.props.scheduledReport.shift
        })
      })

  }

  // ----------------------
  // Methods
  // ----------------------

  onAddAttachment() {
    this.props.addAttachment(this.props.scheduledReport.guid);
  }

  onAddNote() {
    this.props.addNote(this.props.scheduledReport.guid);
  }

  // ----------------------
  // Computed
  // ----------------------

  get hasValidShift() {
    return (this.props.departmentSettings.shifts
      && this.props.departmentSettings.shifts.length
      && this.state.selectedShift)
      || (!this.props.departmentSettings.shifts
        || !this.props.departmentSettings.shifts.length)
  }

  save(dynamicFormData, isAutoSave) {
    if (!isAutoSave && !this.hasValidShift) {
      this.props.notifyError('You need to select shift before submitting the report')
      return;
    }
    const formData = {
      guid: this.props.scheduledReport.guid,
      responses: dynamicFormData.responses,
      signedAt: dynamicFormData.signedAt,
      shift: this.state.selectedShift
    };
    this.props.updateReport(formData, isAutoSave)
      .then(() => {
        this.props.onUpdateReport && this.props.onUpdateReport(this.props.report)
      });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  handleShiftChange(shift) {
    this.setState({
      selectedShift: shift
    });
  }

  render() {
    return (
      this.props.form &&
      this.props.scheduledReport && (
        <Fragment>
          <div className="text-right download-report">
            <div className="oit-fullname">{this.props.scheduledReport.getFullNameFor('acknowledger')}</div>
            <div>
              <button className="button secondary small mr-1" onClick={() => this.formRef.markReportAsNotObserved()}>
                Mark report as not observed
              </button>
              <button className="button secondary small mr-1"
                                                                   onClick={() => this.props.onOpenDictation && this.props.onOpenDictation(this.props.scheduledReport)}>
                Dictation
              </button>
              <button className="button secondary small mr-1" onClick={() => this.props.onOpenTasks && this.props.onOpenTasks(this.props.scheduledReport)}>
                Tasks
              </button>
              <button className="button secondary small mr-1" onClick={() => this.props.onChangePhase && this.props.onChangePhase(this.props.scheduledReport)}>
                Change phase
              </button>
              <a className="button primary small"
                 href={`/api/v1/forms/${this.props.scheduledReport.formGuid}/pdf/${this.state.authToken}`}
                 download={`${this.props.scheduledReport.getFullNameFor('acknowledger').replace(' ', '_')}.pdf`}>
                <i className="fa fa-download" />
                <span>Download blank Form</span>
              </a>
            </div>
          </div>

          {this.props.departmentSettings.shifts && this.props.departmentSettings.shifts.length > 0 &&
          <div className="shift-selection-container">
            <label className="shift-label">
              Select Shift
            </label>

            <div className="dropdown-container">
              <Input
                className="select-shift"
                name="shift"
                onChange={event => this.handleShiftChange(event.target.value)}
                type="select"
                value={this.state.selectedShift}
              >
                <option key="" value=""></option>
                {this.props.departmentSettings.shifts.map((shift) => (
                  <option
                    key={shift}
                    value={shift}
                  >
                    {shift}
                  </option>
                ))}
              </Input>
            </div>
          </div>
          }

          <DynamicForm
            ref={instance => this.formRef = instance}
            layout={this.props.scheduledReport.layout}
            onSave={dynamicFormData => this.save(dynamicFormData)}
            onAutoSave={dynamicFormData => this.save(dynamicFormData, true)}
            responses={this.props.scheduledReport.getResponses()}
            schedule={this.props.scheduledReport.schedule}
            settings={this.props.scheduledReport.settings}
            overrideResponses={this.props.overrideResponses}
            acknowledger={this.props.scheduledReport.acknowledger}
            hasValidShift={this.hasValidShift}
        >
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === '1',
                  })}
                  onClick={() => {
                    this.toggle('1');
                  }}
                >
                  Attachments
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === '2',
                  })}
                  onClick={() => {
                    this.toggle('2');
                  }}
                >
                  Notes
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Col sm="12">
                    <AttachmentList
                      attachments={this.props.attachments}
                      onAdd={() => this.onAddAttachment()}
                      onDelete={index => this.deleteAttachment(index)}
                    />
                    <Modal
                      isOpen={this.props.isAddingAttachment}
                      onClose={() => this.props.closeAddAttachment()}
                      title={`Add Attachment for ${
                        this.props.scheduledReport.formName
                      }`}
                    >
                      <AttachmentAdd />
                    </Modal>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Col sm="12">
                    <NoteList
                      onAdd={() => this.onAddNote()}
                      notes={this.props.notes}
                    />
                    <Modal
                      isOpen={this.props.isAddingNote}
                      onClose={() => this.props.closeAddNote()}
                      title={`Add Note for ${
                        this.props.scheduledReport.formName
                      }`}
                    >
                      <NoteAdd />
                    </Modal>
                    <Modal
                      isOpen={this.props.isEditingNote}
                      onClose={() => this.props.closeEditNote()}
                      title={`Edit Note for ${
                        this.props.scheduledReport.formName
                      }`}
                    >
                      <NoteEdit />
                    </Modal>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </div>
        </DynamicForm>
        </Fragment>
      ) || null
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    attachments: state.attachments.list,
    form: departmentSelectors.selectedFormFor(state),
    isAddingAttachment: !!state.attachments.addingAttachmentFor,
    isAddingNote: !!state.notes.addingNoteFor,
    isAddingScheduedReport: state.trainingPhases.isAddingScheduledReport,
    isEditingNote: !!state.notes.isEditingNote,
    notes: state.notes.list,
    scheduledReport: trainingPhaseSelectors.addingScheduledReport(state),
    trainingPhaseGuid: state.trainingPhases.selectedGuid,
    userContext: state.common.userContext,
    departmentSettings: state.departmentSettings.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addNote: (reportGuid) => {
      return dispatch(notesActionCreators.addNote(reportGuid));
    },
    addAttachment: (reportGuid) => {
      return dispatch(attachmentsActionCreators.addAttachment(reportGuid));
    },
    closeAddAttachment: () => {
      return dispatch(attachmentsActionCreators.closeAddAttachment());
    },
    closeAddNote: () => {
      return dispatch(notesActionCreators.closeAddNote());
    },
    closeEditNote: () => {
      return dispatch(notesActionCreators.closeEditNote());
    },
    loadReportEdit: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.loadReportEdit(reportGuid));
    },
    updateReport: (formData, isAutoSave) => {
      return dispatch(trainingPhasesActionCreators.updateReportResponses(formData, isAutoSave));
    },
    updateReportResponses: (formData) => {
      return dispatch(trainingPhasesActionCreators.updateReportResponses(formData));
    },
    notifyError: (message) =>
      dispatch(notificationsActionsCreator.addError(message))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledReportAdd);
